import React from "react";
import AccountPage from "../../TelaAdministrador/profile/ProfileAdmin";
// Same self-service endpoints and visual components; role controls labels/navigation only.
export default function Page() { return <AccountPage role="Comum" />; }
